export const LayoutType = {
  Layout1: 1,
  // Layout2: 2,
  Layout31: 31,
};

export const LayoutAbbreviation = {
  All: "ALL",
  Layout1: "Layout1",
  // Layout2: "Layout2",
  Layout31: "Layout31",
};

export const LayoutAbbreviations = [
  "Layout1",
  // "Layout2",
  "Layout31",
];
export const LayoutAbbreviationsToRemove = [
  "Layout31",
  // "Layout2",
  "Layout1",
];

export const METADATA = {
  ALL: "ALL"
};

export const DECORS_MAX = 10;
